import { z } from 'zod'

export const AppBuildSchema = z.object({
  version: z.string(),
  hash: z.string().optional(),
  date: z.string().optional(),
})

export type AppBuild = z.infer<typeof AppBuildSchema>
